enum Views {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

enum DetailsViews {
  DATES = "dates",
  PROGRESS = "progress",
}

type Cell = {
  width: number;
  height: number;
};

export type { Cell };

export { Views, DetailsViews };
